import { LuBug, LuBuilding2, LuClipboardList, LuClock, LuCode, LuCpu, LuPalette, LuRocket, LuSmartphone, LuUsers, LuWallet } from "react-icons/lu";

export const LocationBasedHeroData = {
  backgroundImage: "/images/serviceBanners/LOCATION-BASEDEXPERIENTIALMARKETING.webp",
  whiteImage: "/images/serviceBanners/LOCATION-BASEDEXPERIENTIALMARKETINGW.webp",
  subTitle: "Location-Based & Experiential Marketing Solutions",
  title: (
    <>
      High Performance{" "}
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600">Real World Engagement</span>
      <br /> Systems
    </>
  ),
  description:
    "Location based experiential marketing systems that combine digital targeting with real world interactions to deliver highly relevant user engagement, improve conversions, and create meaningful brand experiences at the right time and place.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Geo Targeted Strategy",
      desc: "Design campaigns based on user location for precise targeting.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Real Time Location Engagement",
      desc: "Deliver ads, notifications, and offers based on live physical location.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Event Based Marketing Activation",
      desc: "Engage audiences at exhibitions, festivals, and live events.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Experiential Brand Campaigns",
      desc: "Create immersive real world brand experiences for recall value.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "22%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const locationBasedAboutData = [
  {
    title: "Location Based Marketing Services for Meaningful Customer Engagement",
    content: (
      <>
        Reaching customers at the right moment can significantly improve marketing effectiveness and brand interaction. Professional Location Based Marketing Services help
        organizations connect with audiences based on where they are, what they are doing, and how they interact with their surroundings. Many brands struggle to bridge the gap
        between digital campaigns and real world customer actions. At Tycho Technologies, location focused marketing strategies are designed to create timely and relevant
        experiences that improve engagement while supporting measurable business outcomes.
      </>
    ),
  },
  {
    title: "Experiential Marketing Services That Create Lasting Impressions",
    content: (
      <>
        Consumers are more likely to remember brands that provide memorable and interactive experiences. Effective Experiential Marketing Services help businesses move beyond
        traditional advertising by creating meaningful interactions that strengthen emotional connections with customers. Organizations investing in experience driven campaigns
        often improve brand recall because audiences actively participate rather than simply viewing promotional messages. Tycho Technologies develops experiential strategies that
        help brands create authentic engagement opportunities and build stronger customer relationships.
      </>
    ),
  },
  {
    title: "Geo Targeting Advertising Services for Better Audience Precision",
    content: (
      <>
        Modern marketing success depends on delivering relevant messages to the right audience at the right time. Reliable Geo Targeting Advertising Services help businesses
        improve campaign accuracy by focusing on users within specific locations and geographic segments. Companies that use location intelligence often achieve stronger engagement
        because promotions are aligned with customer context and intent. A targeted approach helps businesses improve campaign efficiency while creating more personalized and
        valuable customer experiences.
      </>
    ),
  },
  {
    title: "Why Businesses Invest in Brand Activation Services",
    content: (
      <>
        The demand for Event Marketing Services and Brand Activation Services continues to grow as businesses seek stronger customer engagement beyond digital channels. Companies
        want marketing strategies that generate real interactions, increase visibility, and strengthen brand recognition. Businesses partnering with Tycho Technologies gain access
        to customized location and experience based campaigns designed around measurable goals and audience behavior. A strategic activation approach helps organizations improve
        customer participation, strengthen brand awareness, and create sustainable growth through memorable real world experiences.
      </>
    ),
  },
];

export const locationBasedDevelopSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Location-Based & Experiential Marketing Solutions for Every Business Requirement",
  buildCards: [
    {
      title: "Geo Targeted Campaign Strategy",
      desc: "Design campaigns based on user location such as malls, stores, events, or competitor areas for precise targeting.",
      icon: LuSmartphone,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Real Time Location Engagement",
      desc: "Deliver ads, notifications, and offers to users based on their live physical location.",
      icon: LuClock,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Event Based Marketing Activation",
      desc: "Engage audiences at exhibitions, festivals, trade shows, and live events for maximum brand exposure.",
      icon: LuBuilding2,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Experiential Brand Campaigns",
      desc: "Create immersive real world brand experiences that increase engagement and recall value.",
      icon: LuUsers,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Competitor Location Targeting",
      desc: "Target users visiting competitor locations with alternative offers and brand messaging.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Footfall Tracking & Analytics",
      desc: "Measure real world visits driven by campaigns and connect digital ads with offline conversions.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Location-Based & Experiential Marketing Engineering Framework",
  processTitle: "How We Build Scalable Real World Marketing Systems",
  processSteps: [
    {
      step: "01",
      title: "Campaign Architecture Planning",
      description: "Define geo targeting strategy, event based planning, and real world audience mapping.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Agile Campaign Execution",
      description: "Run continuous campaign updates based on location data, audience behavior, and engagement signals.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Experience Campaign Development",
      description: "Create interactive real world marketing campaigns designed to increase engagement and brand recall.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Location Data & Targeting System",
      description: "Manage geo fencing, audience segmentation, and real time location based targeting.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Performance Optimization",
      description: "Improve engagement rate, footfall conversions, and campaign effectiveness using data insights.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Quality Assurance & Tracking",
      description: "Ensure accurate tracking of offline conversions, visits, and campaign performance.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY INVEST IN LOCATION BASED MARKETING SYSTEMS?",
  benefitsTitle: "Why Businesses Invest in Location Based Marketing Systems",
  benefits: [
    "Strong real world customer engagement",
    "Higher brand recall through experiences",
    "Accurate footfall tracking",
    "Better conversion from offline audiences",
    "Real time audience targeting capability",
    "Competitive location advantage",
    "Scalable experiential marketing model",
  ],
  logoImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteLogoImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
};

export const locationBasedServices = [
  {
    icon: <LuSmartphone size={36} />,
    title: "Hyperlocal Marketing Campaigns",
    description: "Launch targeted marketing messages to mobile users within exact geographic bounds like storefronts or districts.",
    image: "/images/MobileAppDevelopment/Android-Development.png",
    link: "/location-based-experiential-marketing-services-india#hyperlocal",
  },
  {
    icon: <LuBuilding2 size={36} />,
    title: "Experiential Brand Pop-ups",
    description: "Create memorable physical interactive environments that engage customers offline and amplify online.",
    image: "/images/MobileAppDevelopment/iOS-Custom.png",
    link: "/location-based-experiential-marketing-services-india#experiential-popups",
  },
  {
    icon: <LuCpu size={36} />,
    title: "Footfall Attribution Tracking",
    description: "Connect digital advertising impressions with actual physical store visits and conversions.",
    image: "/images/MobileAppDevelopment/Hybrid-Dev.png",
    link: "/location-based-experiential-marketing-services-india#footfall-attribution",
  },
];

export const locationBasedFaqData = [
  {
    q: "What is Location-Based Marketing and how does it benefit my business?",
    a: "Location-Based Marketing uses geographic data (such as GPS, Wi-Fi, or cell tower signals) to send highly relevant promotional messages or ads to customers on their mobile devices when they are near physical stores, commercial areas, or events. It drives immediate footfall and improves local conversion rates.",
  },
  {
    q: "What is Experiential Marketing?",
    a: "Experiential Marketing is a strategy that focuses on creating interactive, immersive real-world experiences (like pop-up exhibitions, live demos, and branded setups) that encourage consumers to actively participate with a brand. This hands-on interaction leads to much higher brand recall and stronger emotional connection.",
  },
  {
    q: "How does Footfall Tracking connect digital campaigns to offline visits?",
    a: "Through location analytics and attribution tracking, we can verify when a mobile device that was exposed to your digital ad enters your physical store location. This bridges the gap between online spend and offline visits, giving you an accurate picture of campaign ROI.",
  },
  {
    q: "How can we target competitor locations with Geo-Targeting?",
    a: "We can establish virtual geo-fences around competitor locations, showrooms, or high-traffic zones. When potential customers enter these areas, they can be served targeted ads or promotions offering them compelling reasons to visit your brand instead.",
  },
];

export const locationBasedPortfolioData = {
  subtitle: "OUR WORK",
  title: "Experiential Projects We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};
